import {columns} from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/person'
export const namespace = 'person'
export const clientRoute = '/person'
export const dependencies = ['address', 'aspnetuser', 'personCommittee', 'committee', 'personDietOption', 'dietOption', 'company', 'companyDivision', 'division', 'personGrouping', 'grouping', 'membership', 'membershipType']
export const params = {
  include: 'company[membership],aspnetuser,address,personCommittee[committee],personDietOption[dietOption],personGrouping[grouping]',
  odataInclude: 'Company($expand=Membership($expand=MembershipType),CompanyDivision($expand=Division)),Aspnetuser,Address,PersonCommittee($expand=Committee),PersonDietOption($expand=DietOption),PersonGrouping($expand=Grouping)'
}
export const excelExport = {
  select: 'firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender,doNotShare,dietComment,adaRequired,adaComment,toolboxExpiration',
  include:
    'company($select=name,phoneNumber,faxNumber,url,artba,unionStatus,minorityWomanVeteranBusiness,agcaIdentifier,cafIpfValue,cafIpfYear,chaseLevel,chaseLevel1Value,chaseLevel2Value,chaseLevel3Value,chaseLevel3Year,chaseMemberSince,leadershipBlueprint,yearFounded,contractAccess,contractExpiration,directoryNameTitle,profile),' +
    'address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),' +
    'personCommittee($select=committee;$expand=committee($select=name)),' +
    'personDietOption($select=dietOption;$expand=dietOption($select=description)),' +
    'personGrouping($select=grouping;$expand=grouping($select=description))'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'fullName'
const subtitleColumn = 'contactInfo'
const infoColumns = ['emailAddress', 'homeNumber', 'workNumber', 'cellNumber']
const fakeColumns = {
  isActive: 'company',
  membershipType: 'company',
  companyDivision: 'companyDivision',
  userName: 'aspnetuser'
  // contactType: 'company'
}
/* --------------------------- */

const state = {
  columns,
  defaultSort: 'lastName',
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  excelExport,
  titleColumn,
  subtitleColumn,
  infoColumns,
  fakeColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
